var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GChart',{attrs:{"settings":{packages: ['corechart']},"version":'42',"createChart":_vm.createChart}})
}
var staticRenderFns = []

export { render, staticRenderFns }